import { createSlice } from "@reduxjs/toolkit";
import { Portion } from "./setMenuSlice";

export interface MenuItemSection {
    displayName: string;
    maxAllowedCount: number;
    isRequired: boolean;
    customItemType: string;
    availableCount?: number;
    customMenuItemTypeId?: string;
}

export interface ExtraItem {
    menuItemId?: string;
    displayName: string;
    price: number;
    type: string;
    customItemType?: any;
    maxAllowedCount?: any;
    customMenuItemTypeId?: string;
}

export interface CreateCustomizeMenuItem {
    category?: any
    restaurantId: string;
    sections: MenuItemSection[];
    displayName: string;
    abbreviation?: string;
    imageReference: string;
    price: any;
    totalItems: number;
    extraItems?: ExtraItem[];
    allergenInformation?: string[];
    foodAttributes?: string[];
    supportPortionSizes?: boolean;
    portions?: Portion[];
    productId?: string;
    filterTags: string[];
    tags?: any;
    supportsPreOrdering: boolean;
    tinyId?:number;
}

export interface CustomMenuImageUpdateRequest {
    imgRef: string;
    restaurantId: string;
    customMenuId: string;
}

export interface CustomMenuItem {
    availableDays: number[];
    isAvailable: boolean | undefined;
    totalItems: number;
    displayName: string;
    imageUrl: string;
    restaurantId: string;
    sections: MenuItemSection[];
    extraItems?: ExtraItem[];
    status: string;
    id: string;
    price: number;
    priceType: string;
    createdAt: {
        _nanoseconds: number;
        _seconds: number;
    };
    allergenInformation?: string[];
    foodAttributes?: string[];
    supportPortionSizes?: boolean;
    portions?: Portion[];
    category?: any
    quantity?: number;
    portionLabel?: string;
    isCooporateProduct?: boolean;
    organizationIds?: string[];
    productId?: string;
    tinyId?: number;
}

export interface CustomMenuListResponse {
    customMenuList: CustomMenuItem[];
}


export interface UpdateCustomizeMenuItem {
    category?: any;
    restaurantId: string;
    customMenuId?: string;
    sections: MenuItemSection[];
    displayName: string;
    abbreviation?: string;
    totalItems: number;
    price: number;
    extraItems?: ExtraItem[];
    allergenInformation?: string[];
    foodAttributes?: string[];
    supportPortionSizes?: boolean;
    portions?: Portion[];
    productId?: string;
    filterTags?: string[];
    tags?: any;
    supportsPreOrdering?: boolean;
    tinyId?: number;
}

interface IntialStateInterface {
    customizeMenu: any[];
    selectedMenuType: string | null;
    loading: boolean;
    error: any;
    rowsPerPage: number;
}

const initialState: IntialStateInterface = {
    customizeMenu: [],
    selectedMenuType: null,
    loading: false,
    error: null,
    rowsPerPage: 10,
};

const customizeMenuSlice = createSlice({
    name: "customizeMenu",
    initialState,
    reducers: {
        getMenuItemsStart(state) {
            state.loading = true;
            state.error = null;
        },
        getMenuItemsSuccess(state, action) {
            state.customizeMenu = action.payload;
            state.loading = false;
            state.error = null;
        },
        getMenuItemsFailure(state, action) {
            state.loading = false;
            state.error = action.payload;
        },
        setSelectedMenuType(state, action) {
            state.selectedMenuType = action.payload;
        },
        clearSelectedMenuType(state) {
            state.selectedMenuType = null;
        },
        setRowsPerPage(state, action) {
            state.rowsPerPage = action.payload;
        },
        clearRowsPerPage(state) {
            state.rowsPerPage = 10;
        },
        setCustomItems(state, action) {
            state.customizeMenu = action.payload;
        },
    },
});

export const {
    getMenuItemsStart,
    getMenuItemsSuccess,
    getMenuItemsFailure,
    setSelectedMenuType,
    clearSelectedMenuType,
    setRowsPerPage,
    clearRowsPerPage,
    setCustomItems,
} =
    customizeMenuSlice.actions;

export default customizeMenuSlice.reducer;
